/* @flow */
import * as React from 'react';
import { update, create } from 'permissions/modelMasters';
import ManufacturerForm from '../forms/ManufacturerForm/ManufacturerForm';
import { getStore } from '../services/ServiceRegistry';

const manufacturerRoutes: Array<*> = [
  {
    path: '/manufacturers/create',
    title: 'general:document_titles.manufacturers.create',
    component() {
      return <ManufacturerForm mode="create" />;
    },
    exact: true,
    permissions: create,
  },
  {
    path: '/manufacturers/edit',
    title: 'general:document_titles.manufacturers.edit',
    title_keys: ['currentItem.name'],
    component({ location }) {
      const store = getStore(['navigationStore'])[0];
      store.currentItem = location.state?.itemData;
      return (
        <ManufacturerForm mode="edit" itemData={location.state ? location.state.itemData : {}} />
      );
    },
    exact: true,
    permissions: update,
  },
];

export default manufacturerRoutes.map(item => ({
  ...item,
  store: ['navigationStore'],
}));
